import { renderCategoryTable } from './renderCategoryTable'

export const buildCategoryItem = ({ key, t, measure = 'amount', isSI, dataSource, category }) => ({
	key: category,
	label: t(`nutritionalComponents:attributes.categories.${category}.label`),
	children: renderCategoryTable({ key, t, measure, isSI, dataSource, category }),
})
